const TYPES = {
  STRING: 'string',
  OBJECT: 'object'
};

export default function isJSON(value) {
  let result = false;
  let parsedValue = '';
  if (typeof value !== TYPES.STRING) {
    value = JSON.stringify(value);
  }

  try {
    parsedValue = JSON.parse(value);
    result = true;
  } catch (e) {
    result = false;
  }

  return result && typeof parsedValue === TYPES.OBJECT;
}
